<template>
    <v-container title="Мои данные" full>
        <template #actions v-if="showSaveButton">
            <v-btn form="form-profile" v-if="showSaveButton">Сохранить изменения и завершить</v-btn>
        </template>

        <v-loading v-if="loading"></v-loading>
        <v-form v-else id="form-profile" @submit="send">
            <div class="profile-box__wrapper profile-edit">
                <div class="profile-box__header-user">
                    <div class="uploader-box">
                        <form action="">
                            <div class="profile-box__header-user-photo">
                                <div class="h-object-fit">
                                    <img :src="$user.avatar" alt="" />
                                </div>
                            </div>
                            <div class="uploader-box__file profile-box__header-user-data">
                                <label @click="chooseFile">
                                    <!--                                    <input type="file" id="uploadImg">-->
                                    <span class="btn btn_add">Изменить фото профиля</span>
                                </label>
                            </div>
                        </form>
                    </div>
                </div>

                <v-form-wrapper title="Общая информация">
                    <v-form-container>
                        <div class="profile-box__all-info">
                            <v-input name="first_name" title="Имя" rules="required" v-model="request.first_name" />

                            <v-input name="last_name" title="Фамилия" rules="required" v-model="request.last_name" />

                            <v-input name="email" disabled title="Email" :value="request.email" />

                            <v-phone-mask name="phone" title="Телефон" rules="required" v-model="request.phone" />
                        </div>

                        <div class="profile-box__all-info">
                            <v-select
                                name="country_id"
                                title="Страна"
                                rules="required"
                                searchable
                                v-model="request.country_id"
                                :options="countries"
                            />

                            <v-select
                                name="city_id"
                                title="Город"
                                searchable
                                rules="required"
                                v-model="request.city_id"
                                :options="cities"
                                @search="loadCities"
                            />

                            <v-radio
                                name="sex_id"
                                title="Пол"
                                :options="sexes"
                                rules="required"
                                v-model="request.sex_id"
                            />
                        </div>
                    </v-form-container>

                    <v-form-container>
                        <div class="profile-box__all-info reset-password">
                            <v-container-title-wrapper>
                                <v-container-title-name small>Изменить пароль</v-container-title-name>
                                <v-container-title-caption small>
                                    Для изменения пароля введите текущий пароль и нажмите кнопку "Продолжить". Вам на
                                    почту придет ссылка, перейдя по которой вы сможете изменить пароль
                                </v-container-title-caption>
                            </v-container-title-wrapper>
                            <v-password
                                name="old_password"
                                title="Текущий пароль*"
                                v-model="reset.old_password"
                                :error="resetErrors.old_password"
                                :autocomplete="'off'"
                            />
                            <v-password
                                name="new_password"
                                title="Новый пароль*"
                                v-model="reset.password"
                                :error="resetErrors.password"
                                :autocomplete="'off'"
                            />
                            <v-password
                                name="confirm_password"
                                title="Подтвердить пароль*"
                                v-model="reset.password_confirmation"
                                :error="resetErrors.password_confirmation"
                                :autocomplete="'off'"
                            />
                            <v-btn @click.prevent="resetPassword" type="button">Продолжить</v-btn>
                        </div>

                        <div class="profile-box__all-info">
                            <div class="profile-box__all-info-content">
                                <div
                                    class="profile-box__all-info-content-title profile-box__all-info-content-title-social"
                                >
                                    Соц. сети
                                    <div class="add-input-box__action">
                                        <v-btn :to="{ name: 'profile-edit-social' }" class="btn btn_add">
                                            <v-icon src="plus" />
                                            <span>Add Account</span>
                                        </v-btn>
                                    </div>
                                </div>
                                <div class="list-options">
                                    <div
                                        v-for="(soc, index) in $user.socialNetworks"
                                        :key="`soc_${index}`"
                                        class="list-options-item"
                                    >
                                        <img :src="soc.icon" style="width: 24px" />
                                        <div class="list-options-item-content">
                                            {{ soc.url }}
                                            <button type="button" @click="toEditSocial">
                                                <v-icon src="edit" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-form-container>
                </v-form-wrapper>
            </div>
        </v-form>
    </v-container>
</template>

<script>
import { mapMutations } from "vuex";
// import {avatarMutator} from "../../helpers";

export default {
    name: "ProfileForm",
    $_veeValidate: {
        validator: "new"
    },
    data() {
        return {
            loading: true,
            countries: [],
            cities: [],
            sexes: [],
            reset: {
                old_password: "",
                password: "",
                password_confirmation: ""
            },
            resetErrors: {
                old_password: "",
                password: "",
                password_confirmation: ""
            },
            /*   errors: {
                   old_password: "",
                   password: "",
                   password_confirmation: ""
               },*/
            request: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                country_id: null,
                city_id: null,
                sex_id: null
            },
            showSaveButton: false
        };
    },
    mounted() {
        this.$set(this.request, "first_name", this.$user.first_name);
        this.$set(this.request, "last_name", this.$user.last_name);
        this.$set(this.request, "email", this.$user.email);
        this.$set(this.request, "phone", this.$user.phone);

        if (this.$user.country) {
            this.$set(this, "countries", [
                {
                    value: this.$user.country.id,
                    label: this.$user.country.name
                }
            ]);
        }
        this.$nextTick(() => {
            if (this.$user.city) {
                this.$set(this, "cities", [
                    {
                        value: this.$user.city.id,
                        label: this.$user.city.name
                    }
                ]);
            }
            this.$set(this.request, "city_id", this.$user.city ? this.$user.city.id : null);
        });
        this.$set(this.request, "country_id", this.$user.country ? this.$user.country.id : null);
        this.$set(this.request, "sex_id", this.$user.sex ? this.$user.sex.id : null);
        this.loadCountries();
        this.loadSexs();
    },
    watch: {
        request: {
            handler() {
                if (this.showSaveButton) return;
                this.showSaveButton = true;
            },
            deep: true
        },
        "request.country_id": function() {
            this.$set(this.request, "city_id", null);
            this.$set(this, "cities", []);
        }
    },
    methods: {
        ...mapMutations("auth", ["SAVE_USER"]),

        chooseFile() {
            this.openModal("Files", {
                multiple: false,
                type: "photos"
            }).then(data => {
                this.$user.avatar = this.avatarMutator(data);
                this.$api.auth.updateAvatar(data.id).then(() => {
                    //this.$user.avatar = this.avatarMutator(data);
                });
            });
        },

        send() {
            this.validate().then(() => {
                this.loading = true;
                this.$api.auth
                    .update(this.request, this._uid)
                    .then(({ data }) => {
                        let user = data.data;
                        this.SAVE_USER(user);

                        // this.$set(this.request, 'password', null)
                        // this.$set(this.request, 'password_confirmation', null)

                        // this.notify('Изменения успешно внесены', null, 'success')
                        this.loading = false;
                        this.$router.push({ name: "profile" });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
        loadCountries() {
            this.$api.data.countries().then(({ data }) => {
                let countries = data.data.map(data => ({
                    value: data.id,
                    label: data.title
                }));
                this.$set(this, "countries", countries);
                this.loadSexs();
            });
        },
        loadSexs() {
            this.$api.data.sexs().then(({ data }) => {
                this.$set(
                    this,
                    "sexes",
                    data.data.map(data => {
                        return {
                            value: data.id,
                            label: data.name
                        };
                    })
                );
                this.loading = false;
            });
        },
        loadCities(q) {
            if (this.request.country_id && q) {
                this.$api.data.cities(this.request.country_id, q).then(({ data }) => {
                    this.cities = data.data.map(data => {
                        return {
                            value: data.id,
                            label: data.title + (data.region ? ` (${data.region})` : ``)
                        };
                    });
                });
            }
        },
        toEditSocial() {
            this.$router.push({ name: "profile-edit-social" });
        },
        resetPassword() {
            this.$api.restore
                .reset(this.reset)
                .then(() => {
                    this.resetErrors = {};
                    this.reset = {
                        old_password: "",
                        password: "",
                        password_confirmation: ""
                    };
                    this.notify({ title: "Пароль изменен" });
                })
                .catch(({ data }) => {
                    this.notify({ title: "Не вышло", type: "error" });
                    Object.entries(this.resetErrors).forEach(([key, err]) => {
                        if (key in data.errors) {
                            this.resetErrors[key] = data.errors[key].join("");
                        } else {
                            this.resetErrors[key] = "";
                        }
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.reset-password {
    .form-group {
        //margin-bottom: 0 !important;
    }
}
</style>
